import React, { useEffect, useState } from "react";
import http from "../lib/http";
import SEO from "../components/SEO/SEO";

export default function AdminDashboard() {

  const [stats, setStats] = useState({
    totalDealers: 0,
    activeDealers: 0,
    pendingDealers: 0,
    totalReviews: 0,
    pendingReviews: 0,

    trialDealers: 0,
    expiringSoon: 0,
    expiredDealers: 0,
    monthlyRevenue: 0,
  });

  const [recentDealers, setRecentDealers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDashboard = async () => {
    try {

      setLoading(true);

      const dealerRes = await http.get("/api/dealers");

      const dealers = dealerRes.data.filter(
        (d) => !d.isDeleted
      );

      const totalDealers = dealers.length;

      const activeDealers = dealers.filter(
        (d) => d.isActive
      ).length;

      const pendingDealers = dealers.filter(
        (d) => !d.isActive
      ).length;

      let totalReviews = 0;
      let pendingReviews = 0;
      let trialDealers = 0;
      let expiringSoon = 0;
      let expiredDealers = 0;
      let monthlyRevenue = 0;

      dealers.forEach((dealer) => {

        const sub = dealer.subscription;

        if (sub) {

          if (sub.plan === "TRIAL") {
            trialDealers++;
          }

          const daysLeft = Math.ceil(
            (
              new Date(sub.expiryDate) -
              new Date()
            ) /
            (1000 * 60 * 60 * 24)
          );

          if (daysLeft <= 7 && daysLeft > 0) {
            expiringSoon++;
          }

          if (
            sub.status === "EXPIRED" ||
            daysLeft <= 0
          ) {
            expiredDealers++;
          }

          monthlyRevenue +=
            sub.amountPaid || 0;
        }
        totalReviews += dealer.reviews?.length || 0;

        pendingReviews +=
          dealer.reviews?.filter((r) => !r.approved).length || 0;
      });

      setStats({
      totalDealers,
      activeDealers,
      pendingDealers,
      totalReviews,
      pendingReviews,

      trialDealers,
      expiringSoon,
      expiredDealers,
      monthlyRevenue,
    });

      setRecentDealers(
        dealers.slice(-5).reverse()
      );

    } catch (err) {
      console.error("Dashboard fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <>
    <SEO
    title="Admin Dashboard"
    noIndex={true}
/>

    <div>

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">

        <div>
          <h2 className="fw-bold mb-1">
            Admin Dashboard
          </h2>

          <p className="text-muted mb-0">
            Welcome back to BuildNear Admin Panel
          </p>
        </div>

        <div className="badge bg-primary p-3">
          Active Dealers: {stats.activeDealers}
        </div>

      </div>

      {/* Cards */}
      <div className="row g-4 mb-4">

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">

            <div className="card-body">

              <h6 className="text-muted">
                Total Dealers
              </h6>

              <h2 className="fw-bold">
                {stats.totalDealers}
              </h2>

            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">

            <div className="card-body">

              <h6 className="text-muted">
                Active Dealers
              </h6>

              <h2 className="fw-bold text-success">
                {stats.activeDealers}
              </h2>

            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">

            <div className="card-body">

              <h6 className="text-muted">
                Pending Dealers
              </h6>

              <h2 className="fw-bold text-warning">
                {stats.pendingDealers}
              </h2>

            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">

            <div className="card-body">

              <h6 className="text-muted">
                Pending Reviews
              </h6>

              <h2 className="fw-bold text-danger">
                {stats.pendingReviews}
              </h2>

            </div>
          </div>
        </div>

      </div>

    <div className="row g-4 mb-4">

  <div className="col-md-3">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">

        <h6 className="text-muted">
          Trial Dealers
        </h6>

        <h2 className="fw-bold text-info">
          {stats.trialDealers}
        </h2>

      </div>
    </div>
  </div>

  <div className="col-md-3">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">

        <h6 className="text-muted">
          Expiring in 7 Days
        </h6>

        <h2 className="fw-bold text-warning">
          {stats.expiringSoon}
        </h2>

      </div>
    </div>
  </div>

  <div className="col-md-3">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">

        <h6 className="text-muted">
          Expired Dealers
        </h6>

        <h2 className="fw-bold text-danger">
          {stats.expiredDealers}
        </h2>

      </div>
    </div>
  </div>

  <div className="col-md-3">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">

        <h6 className="text-muted">
          Revenue
        </h6>

        <h2 className="fw-bold text-success">
          ₹{stats.monthlyRevenue}
        </h2>

      </div>
    </div>
  </div>

</div>

      {/* Recent Dealers */}
      <div className="card border-0 shadow-sm">

        <div className="card-header bg-white border-0 py-3">

          <div className="d-flex justify-content-between align-items-center">

            <h5 className="mb-0 fw-bold">
              Recent Dealer Registrations
            </h5>

          </div>

        </div>

        <div className="card-body">

          {recentDealers.length === 0 ? (

            <div className="text-center py-5 text-muted">
              No dealers found
            </div>

          ) : (

            <div className="table-responsive">

              <table className="table align-middle">

                <thead className="table-light">

                  <tr>
                    <th>Dealer</th>
                    <th>Category</th>
                    <th>Contact</th>
                    <th>Status</th>
                  </tr>

                </thead>

                <tbody>

                  {recentDealers.map((dealer) => (

                    <tr key={dealer._id}>

                      <td>

                        <div className="d-flex align-items-center gap-3">

                          <img
                            src={
                              dealer.image
                                ? `http://localhost:5000${dealer.image}`
                                : "https://via.placeholder.com/50"
                            }
                            alt={dealer.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "12px",
                              objectFit: "cover",
                            }}
                          />

                          <div>

                            <div className="fw-semibold">
                              {dealer.name}
                            </div>

                            <small className="text-muted">
                              {dealer.locationName}
                            </small>

                          </div>

                        </div>

                      </td>

                      <td>
                        {dealer.category}
                      </td>

                      <td>
                        {dealer.contact}
                      </td>

                      <td>

                        {dealer.isActive ? (
                          <span className="badge bg-success">
                            Active
                          </span>
                        ) : (
                          <span className="badge bg-warning text-dark">
                            Pending
                          </span>
                        )}

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    </div>
        </>
  );
}